var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseicon = function SvgPauseicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22.57,
    stroke: "#090023",
    strokeWidth: 2.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#090023",
    fillRule: "evenodd",
    d: "M16.5 33.737h5v-17.5h-5zm9.999-17.5v17.5h5v-17.5z",
    clipRule: "evenodd"
  })));
};
export default SvgPauseicon;